module.exports = __webpack_public_path__ + "img/cmbs-surveillance-1.a0bcc83a.svg";